export default `
<svg style="margin:auto;display:block;width:200px; height: 200px; position: fixed; top: 50%; left: 50%; transform: translate(-50%, -50%)" width="198 " height="198" viewBox="0 0 198 198" fill="none" xmlns="http://www.w3.org/2000/svg"  xmlns:xlink="http://www.w3.org/1999/xlink">
    <style>
        #front{fill:#e51544;}
        #light{fill:#F7EFEF;}
        ._transformer{transform-box: fill-box; transform-origin: center;}
        #light-mask rect{
            animation: highlight 4s infinite;
        }
        @keyframes highlight {
            0%{
                transform: translate(0px,180px) rotate(315deg);
            }
            100%{
                transform: translate(0px,-180px) rotate(315deg);
            }
        }
    </style>
    <defs>

        <path
            id="question"
            stroke="0"
            transform="matrix(1.3333333,0,0,-1.3333333,0,181.49333) scale(0.1)"
        >
            <animate
                    attributeName="d"
                    calMode="spline"
                    style="fill:#e51544;fill-opacity:1;fill-rule:nonzero;stroke:none"
                    values="m 956.203,1361.16 c -193.844,0 -331.508,-153.91 -331.508,-343.78 0,-21.435 2.266,-42.317 6.094,-62.665 h 59.172 c -3.332,14.726 -5.223,29.988 -5.223,45.695 0,116.3 96.246,210.57 214.981,210.57 118.731,0 214.971,-94.27 214.971,-210.57 0,-116.285 -90.41,-212.004 -245.788,-332.226 C 728.73,559.727 659.258,457.828 632.414,369.414 630.625,363.516 258.945,1262.54 258.945,1262.54 H 0 L 529.957,0 H 766.184 L 744.457,55.2305 C 711.168,158.969 672.418,392.41 918.254,555.793 c 199.366,132.496 388.916,271.723 388.916,461.587 0,189.87 -157.13,343.78 -350.967,343.78"
                    dur="5s"
                    keySpline=".42,0,.58,1;.42,0,.58,1"
                    repeatCount="indefinite"
            />
        </path>
    </defs>

    <linearGradient id="light-gradient">
        <stop offset="0%" stop-color="#ffffff00"/>
        <stop offset="10%" stop-color="#FFF"/>
        <stop offset="90%" stop-color="#FFF"/>
        <stop offset="100%" stop-color="#ffffff00"/>
    </linearGradient>
    <mask id="light-mask"> <rect y="-30" x="90" class="_transformer" width="20" height="300" fill="url(#light-gradient)" /> </mask>

    <use id="front" href="#question" fill="#e51544"/>
    <use id="light" href="#question" mask="url(#light-mask)" fill="#EFE6CC"/>
</svg> `;
